/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Box,
  Typography,
} from '@material-ui/core';
import Image from 'material-ui-image';
import { SnackbarProvider } from 'notistack';
import AddCircle from '@material-ui/icons/AddCircleOutline';
import formStyle, { WrapContainer, MessageRequired } from './formStyle';
import {
  CustomInput, Toaster, ProgressBar, CustomSelect,
} from '../../../components';
import { Rules } from '../../../helpers/RHFRules';
import { ActionPopUp } from '../../../Layouts';
import {
  createCategoriesPaymentService,
} from '../../../services';

const ActionForm = ({
  open,
  data,
  title,
  onClose,
  getCategories,
  defaultValues,
  setDefaultValues,
  categories,
  updateCategory,
  vendorOptions,
}) => {
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const [invalidImageLit, setInvalidImageLit] = useState('');
  const [fileNameLit, setFileNameLit] = useState('');
  const [startBarProgressLit, setStartBarProgressLit] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [files, setFiles] = useState([]);
  const providerRef = React.useRef();
  const classes = formStyle();

  const {
    handleSubmit, control, errors, reset, setError, clearErrors,
  } = useForm({ defaultValues });

  const resetFields = () => {
    setFiles([]);
    setInvalidImageLit('');
    setFileNameLit('');
    setStartBarProgressLit(false);
    setDefaultValues({
      nameCategory: '',
      fileIcon: '',
      order: '',
    });
  };

  const createCategory = async (category) => {
    const res = await createCategoriesPaymentService(category)
      .catch(() => setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' }));

    if (res?.status !== 201) {
      return setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' });
    }
    resetFields();
    return true;
  };

  const handleOnclose = () => {
    resetFields();
    onClose();
    setImagePreview(null);
  };

  const handleSave = async (dataParam) => {
    if (fileNameLit === '' && data === null) {
      setError('imageLit', 'Campo obligatorio');
      return;
    }
    if (dataParam.order < 1 || dataParam.order > 99) {
      setAlert({ status: true, type: 'error', message: 'El numero de orden debe estar entre 1 y 99' });
      return;
    }
    let imagesBase64 = (data !== null && data.icon_base64) ? data.icon_base64 : defaultValues.categoryIdUrlImg;
    files.forEach((file) => {
      const uploadedFile = file.uploaded_file;
      const imageBase64 = uploadedFile;
      if (file.file_id === 'fileIcon') {
        imagesBase64 = imageBase64 !== undefined ? imageBase64.split(',')[1] : defaultValues.categoryIdUrlImg;
      }
    });
    if (!dataParam.nameCategory.replace(/\s/g, '').length || dataParam.nameCategory === '') {
      setAlert({ status: true, type: 'error', message: 'El nombre de la categoría es inválido' });
      return;
    }
    const cateforyIdDate = new Date();

    const body = {
      id: defaultValues.id || '',
      categoryId: defaultValues.categoryId || `cat-${cateforyIdDate.getDate()}-${cateforyIdDate.getMonth()}-${cateforyIdDate.getFullYear()}-${cateforyIdDate.getHours()}-${cateforyIdDate.getMinutes()}-${cateforyIdDate.getSeconds()}`,
      categoryType: defaultValues.categoryType || 'Pagos',
      creditorAgent: dataParam.nameCategory,
      vendor: dataParam.vendor,
      vendorId: dataParam.vendor === 'PagaTodo' ? 1 : 2,
      categoryIdUrlImg: imagesBase64,
      decription: defaultValues.description || '',
      label: defaultValues.label || '',
      status: defaultValues.status ?? 'true',
      orderId: `${dataParam.order}`,
      serviceId: defaultValues.serviceId || '',
      serviceType: defaultValues.serviceType || '',
    };

    let isSavedorUpdate = false;
    let message;
    if (data) {
      isSavedorUpdate = await updateCategory(body);
      resetFields();
      message = 'Se ha editado la categoria exitosamente';
    } else {
      const categoryOrder = categories.find((categoryRow) => categoryRow.order === parseInt(dataParam.order, 10));
      if (categoryOrder !== undefined || categoryOrder === false) {
        setAlert({ status: true, type: 'error', message: 'El numero de orden ya ha sido usado. El numero de orden debe estar entre 1 y 99' });
        return;
      }

      isSavedorUpdate = await createCategory(body);
      message = 'Se ha creado la categoria exitosamente';
    }
    if (isSavedorUpdate) {
      await getCategories();
      providerRef.current.enqueueSnackbar(message, {
        variant: 'success',
        anchorOrigin: {
          vertical: 'botom',
          horizontal: 'center',
        },
      });
      resetFields();
      onClose();
      setImagePreview(null);
    }
  };

  useEffect(() => {
    if (fileNameLit !== '') {
      clearErrors('imageLit');
    }
  }, [fileNameLit]);

  const onFileUploadIcon = (event) => {
    event.preventDefault();
    setInvalidImageLit('');
    // Get the file Id
    const { id } = event.target;
    // eslint-disable-next-line camelcase
    const file_reader = new FileReader();
    // Get the actual file itself
    const file = event.target.files[0];
    if (!file.name.toLowerCase().match(/\.(png)$/)) {
      setInvalidImageLit('Debe cargar un archivo valido (png).');
      return false;
    }

    if (file.size > 1000) {
      setInvalidImageLit('El tamaño del archivo supera el máximo permitido (1KB).');
      return false;
    }
    setStartBarProgressLit(true);
    file_reader.onload = () => {
      setFiles([...files, { file_id: id, uploaded_file: file_reader.result }]);
      setImagePreview(file_reader.result);
    };
    setFileNameLit(file !== null && file.name !== null ? file.name : '');
    setTimeout(() => {
      if (file && file.name !== '') {
        setStartBarProgressLit(false);
      }
    }, 2000);

    // reading the actual uploaded file
    file_reader.readAsDataURL(file);
  };

  useEffect(() => {
    reset(defaultValues);
  }, [open]);

  return (
    <SnackbarProvider ref={providerRef}>
      <ActionPopUp
        open={open}
        data={data}
        title={title}
        onClose={handleOnclose}
        onSave={handleSubmit(handleSave)}
        enabledControls
      >

        <>
          <WrapContainer marginTop={15}>&nbsp;</WrapContainer>
          <form noValidate autoComplete="off">
            <Grid
              container
              justifyContent="space-evenly"
              alignItems="stretch"
              spacing={2}
            >
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomInput
                  label="Nombre categoria*"
                  name="nameCategory"
                  control={control}
                  rule={Rules.required}
                  error={errors}
                  inputProps={{
                    maxLength: 30,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomInput
                  label="Orden *"
                  name="order"
                  control={control}
                  inputMode="numeric"
                  pattern="[1-9]*'"
                  type="number"
                  rule={Rules.required}
                  error={errors}
                  inputProps={{
                    maxLength: 2,
                    max: 99,
                    min: 1,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomSelect
                  label="Facturador *"
                  name="vendor"
                  control={control}
                  rule={Rules.required}
                  error={errors}
                  options={vendorOptions}
                  disabled={vendorOptions.length === 0}
                />
              </Grid>
              <Grid container item xs={12} sm={12} md={4} lg={4} justifyContent="center" alignItems="center" direction="column">
                <Box display="flex" className={classes.uploadImage}>
                  <label htmlFor="fileIcon">
                    <input
                      onChange={onFileUploadIcon}
                      id="fileIcon"
                      accept=".png"
                      type="file"
                      style={{ display: 'none' }}
                    />
                    <Button
                      color="inherit"
                      variant="contained"
                      component="span"
                      className={classes.buttonImage}
                      endIcon={<AddCircle htmlColor="#50B940" className={classes.mat_icon} />}
                    >
                      IMAGEN ICONO (40 x 40 px)
                    </Button>

                    {invalidImageLit && (
                    <Typography className={classes.formErrors}>
                      {invalidImageLit}
                    </Typography>
                    )}
                  </label>
                  <Box style={{ width: '100%', paddingLeft: 15 }}>
                    <Typography className={classes.formLabel}>
                      {fileNameLit}
                    </Typography>
                    <Box style={{ width: '70%' }}>
                      <ProgressBar
                        startBarProgress={startBarProgressLit}
                      />
                    </Box>
                  </Box>
                </Box>
                {(data !== null && data.icon_base64 && imagePreview === null) && (
                  <>
                    <Image
                      name="imageActual"
                      src={data.icon_base64}
                      style={{ width: 60 }}
                      aspectRatio={(60 / 10)}
                    />
                    <span htmlFor="imageActual">Imagen actual</span>
                  </>
                )}
                {(imagePreview !== null) && (
                  <>
                    <Image
                      name="imagepreview"
                      src={imagePreview}
                      style={{ width: 60 }}
                      aspectRatio={(60 / 10)}
                    />
                    <span htmlFor="imagepreview">Nueva Imagen</span>
                  </>
                )}
                {
                Object.keys(errors).length > 0 && fileNameLit === '' && data === null
                && (
                <>
                  <MessageRequired>Campo obligatorio</MessageRequired>
                </>
                )
              }
              </Grid>
            </Grid>
            <WrapContainer marginTop={15}>&nbsp;</WrapContainer>
          </form>
        </>

        <Toaster
          show={alert.status}
          type={alert.type}
          text={alert.message}
          onClose={() => setAlert({ ...alert, status: false })}
        />
      </ActionPopUp>
    </SnackbarProvider>
  );
};

ActionForm.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActionForm;
